import React, { useState } from 'react';

export default function Note({ note, onDelete, onUpdate }) {
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState(note.title);
  const [body, setBody] = useState(note.body);

  function saveChanges() {
    onUpdate({ ...note, title: title.trim(), body: body.trim(), updatedAt: Date.now() });
    setEditing(false);
  }

  return (
    <div className="note">
      <div className="actions">
        <button onClick={() => setEditing(!editing)}>
          {editing ? 'Cancel' : 'Edit'}
        </button>
        <button onClick={() => onDelete(note.id)}>Delete</button>
      </div>

      {editing ? (
        <>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Title"
          />
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Write your note..."
          />
          <button onClick={saveChanges}>Save</button>
        </>
      ) : (
        <>
          <h3>{note.title || 'Untitled'}</h3>
          <small>{new Date(note.updatedAt || note.createdAt).toLocaleString()}</small>
          <p>{note.body}</p>
        </>
      )}
    </div>
  );
}
